import { mapBuildingIdToDiscountEvent } from "../constants/mapBuildingIdToDiscountEvent";
import { selectActiveDiscountEventInfoByEventType, selectEventInfo } from "./selectEventInfo";
export var selectSelectedDiscountEventId = function (state) {
    return state.discountEvent ? state.discountEvent.selectedEventId : undefined;
};
export var selectSelectedDiscountEvent = function (state) {
    var selectedEventId = selectSelectedDiscountEventId(state);
    return selectedEventId ? selectEventInfo(state, selectedEventId) : undefined;
};
export var selectActiveDiscountEventForBuildingId = function (state, buildingId) {
    var eventType = mapBuildingIdToDiscountEvent.get(buildingId);
    if (eventType !== undefined) {
        return selectActiveDiscountEventInfoByEventType(state, eventType);
    }
    return undefined;
};
export var selectDiscountedBuildingIds = function (state) {
    return Array.from(mapBuildingIdToDiscountEvent.keys())
        .filter(function (buildingId) { return selectHasActiveDiscountForBuildingId(state, buildingId); })
        .map(function (buildingId) { return buildingId; });
};
export var selectHasActiveDiscountForBuildingId = function (state, buildingId) {
    return selectActiveDiscountEventForBuildingId(state, buildingId) !== undefined;
};
export var selectHideDiscountEventActionButton = function (state, eventId) {
    return state.discountEvent ? state.discountEvent.hideActionButtons.has(eventId) : false;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectDiscountEvent.ts
// module id = 207
// module chunks = 3